import { Factory } from '@wix/fe-essentials-viewer-platform/bi';
import type { EcomPlatformViewerScriptContext } from '../../../../viewer-script/types';
import { Logger } from '@wix/web-bi-logger/dist/src/types';
import {
  clickContinueEWalletModalSf,
  checkoutRedirectToCheckoutFromExpressCheckout,
} from '@wix/bi-logger-ecom-platform-data/v2';

export class ExpressCheckoutBIService {
  private readonly logger!: Logger;

  constructor(context: EcomPlatformViewerScriptContext) {
    const loggerFactory = context.platformAPIs.biLoggerFactory?.();
    /* istanbul ignore if */
    if (!loggerFactory) {
      return;
    }

    this.logger = fixOldLoggerFactoryDueToWorkerYoshiV4(loggerFactory)
      .updateDefaults({
        bi_token: context.platformAPIs.bi?.biToken,
        appName: 'Express Checkout',
        _msid: context.platformAPIs.bi?.metaSiteId,
      })
      .logger();
  }

  public clickContinueEWalletModalSf(checkoutId: string) {
    void this.logger.report(
      clickContinueEWalletModalSf({
        checkoutId,
      }),
    );
  }

  public reportNavigateToFastFlowCheckout({
    checkoutId,
    cartId,
    purchaseFlowId,
    reason,
  }: {
    checkoutId: string;
    cartId?: string;
    purchaseFlowId?: string;
    reason: string;
  }) {
    void this.logger.report(
      checkoutRedirectToCheckoutFromExpressCheckout({
        cartId,
        checkoutId,
        purchaseFlowId,
        reason,
      }),
    );
  }
}

function fixOldLoggerFactoryDueToWorkerYoshiV4(factory: Factory): Factory {
  /* istanbul ignore else */
  if ((factory as any).factory) {
    return (factory as any).factory() as Factory;
  }
  /* istanbul ignore next */
  return factory;
}
